import axios from 'axios';
import OssaService from './service';
import { OSSA_BASE_URL } from './config';

export default (): OssaService => {
  // Создаем стандартный Axios клиент
  const httpClient = axios.create({
    baseURL: OSSA_BASE_URL,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return new OssaService(httpClient);
};
